import qs from 'qs';
import { SearchForRetail } from '@/client/api';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
const EXPERIMENT_STATS_CACHE_TTL_SECONDS = 300;
export const experimentStatisticsApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        getRuleExperimentStatistics: builder.query({
            query: ({ areaId, ruleName, dateRange, dateGranularity, }) => {
                const queryString = qs.stringify({
                    areaId, ruleName, dateRange, dateGranularity,
                });
                return {
                    url: `/${SearchForRetail.ANALYTICS_PATH}/experiment/statistics?${queryString}`,
                    method: 'GET',
                };
            },
            transformResponse: (response) => response,
            providesTags: [CC_API_TAGS.ExperimentStatistics],
            keepUnusedDataFor: EXPERIMENT_STATS_CACHE_TTL_SECONDS,
        }),
    }),
});
export const { useGetRuleExperimentStatisticsQuery } = experimentStatisticsApi;
